export const DROPDOWN_GROUPS = [ 'amenities', 'type', 'sort_by' ]
